
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire6a03"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire6a03"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("27Lyk", function(module, exports) {

$parcel$export(module.exports, "register", () => $18c11f3350a906ea$export$6503ec6e8aabbaf, (v) => $18c11f3350a906ea$export$6503ec6e8aabbaf = v);
var $18c11f3350a906ea$export$6503ec6e8aabbaf;
var $18c11f3350a906ea$export$f7ad0328861e2f03;
"use strict";
var $18c11f3350a906ea$var$mapping = new Map();
function $18c11f3350a906ea$var$register(baseUrl, manifest) {
    for(var i = 0; i < manifest.length - 1; i += 2)$18c11f3350a906ea$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $18c11f3350a906ea$var$resolve(id) {
    var resolved = $18c11f3350a906ea$var$mapping.get(id);
    if (resolved == null) throw new Error("Could not resolve bundle with id " + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$18c11f3350a906ea$export$6503ec6e8aabbaf = $18c11f3350a906ea$var$register;
$18c11f3350a906ea$export$f7ad0328861e2f03 = $18c11f3350a906ea$var$resolve;

});

var $6404e075d430c9c7$exports = {};

(parcelRequire("27Lyk")).register(new URL("", import.meta.url).toString(), JSON.parse('["Y15zO","index.fd98fb5d.js","8JTl6","home1.11f29a3f.png","ewZ5P","building.8c7b8c58.jpg","ldx6e","event-hall.03710664.jpg","caMpv","main-pool.7498aaa9.jpg","6Du4l","building-view.ee9face4.jpg","PgSfU","dinning-area.76b6d3be.jpg","apC8X","staff.1d150571.jpg","fjnM7","bedroom.23c1216a.jpg","a7x7u","dinning-area3.178d232b.jpg","6TsLa","banquet_event.70d92fc4.jpg","7SEn8","party-area.c79612ac.jpg","50tjx","zym.bca2d9bc.jpg","irFs9","sitting-area2.c0e66f71.jpg","k86pe","mainEntrance.3bdf79c4.jpg","2RMFQ","serving-area.39173dea.jpg","8Rqin","parking.d2bbd5ee.jpg","2JQMI","washroom.070fd83a.jpg","28H6Z","wifi.7390903d.png","gm26G","banPets.d1aec61f.png","5OeI4","carRental.a0b857d5.png","3NJUs","customerSupport.824237ac.png"]'));


//# sourceMappingURL=index.runtime.327ad3dd.js.map
